function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(".menu-drawer__close-button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.classList.add("closing");
    setTimeout(() => {
      this.removeAttribute("open");
      this.classList.remove("closing");
    }, 300);
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      console.log(modal);
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    window.poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    // const resizeObserver = new ResizeObserver((entries) => this.initPages());
    // resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();
    this.setDragSlide();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setDragSlide() {
    var dragged = false;
    var oldX = 0;
    var this2 = this;
    this.addEventListener("mousedown", function (e) {
      oldX = e.pageX;
      dragged = false;
    });
    this.addEventListener("touchstart", function (e) {
      oldX = e.pageX;
      dragged = false;
    });
    this.addEventListener("mousemove", function () {
      dragged = true;
    });
    this.addEventListener("touchmove", function () {
      dragged = true;
    });
    this.addEventListener("mouseup", function (e) {
      var direction = "left";
      if (dragged == true && e.pageX < oldX) {
        direction = "left";
      } else if (dragged == true && e.pageX > oldX) {
        direction = "right";
      }
      console.log(direction);
      const isFirstSlide = this2.currentPage === 1;
      const isLastSlide = this2.currentPage === this2.sliderItemsToShow.length;

      //if (!isFirstSlide && !isLastSlide) return;

      if (dragged == true && direction == "left") {
        if (isLastSlide) {
          this2.slideScrollPosition = 0;
        } else {
          this2.slideScrollPosition =
            this2.slider.scrollLeft +
            this2.slider.querySelector(".slideshow__slide").clientWidth;
        }
        this2.slider.scrollTo({
          left: this2.slideScrollPosition,
        });
        console.log(this2.slideScrollPosition + " dddd");
      } else if (dragged == true && direction == "right") {
        if (isFirstSlide) {
          this2.slideScrollPosition =
            this2.slider.scrollLeft +
            this2.sliderFirstItemNode.clientWidth *
              this2.sliderItemsToShow.length;
        } else {
          this2.slideScrollPosition =
            this2.slider.scrollLeft -
            this2.slider.querySelector(".slideshow__slide").clientWidth;
        }
        this2.slider.scrollTo({
          left: this2.slideScrollPosition,
        });
        console.log(this2.slideScrollPosition + " dddd");
      }
      dragged = false;
    });
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.legends = [...this.querySelectorAll(".option-title[data-option]")].map(
      (el) => ({ el: el, position: el.dataset.option })
    );
    this.onVariantChange();
  }

  // Changed by Bemeir. LLC when upgrading needs to be changed from the original again.
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
    // When variant is changed post a message with the variant's data
    window.postMessage(
      {
        type: "variant_changed",
        variant: this.currentVariant,
      },
      "*"
    );
  }

  setLegendValues() {
    this.legends.forEach(({ el, position }) => {
      const url_variant_id = new URL(window.location.href).searchParams.get(
        "variant"
      );
      const variantData = this.getVariantData();
      const variant =
        this.currentVariant ||
        variantData.find((v) => v.id == url_variant_id) ||
        variantData[0];
      el.textContent = variant[`option${position}`];
    });
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    var varaintdata = this.getVariantData();
    var this2 = this;
    if (
      $('.product-form__input input[name="Color"]').length > 0 &&
      $('.product-form__input input[name="Size"]').length > 0
    ) {
      $('.product-form__input input[name="Size"]').each(function () {
        var selcolor = $(
          '.product-form__input input[name="Color"]:checked'
        ).val();
        var size = $(this).val();
        for (let index = 0; index < varaintdata.length; index++) {
          var thisvar = varaintdata[index];
          if (thisvar.option1 == selcolor && thisvar.option2 == size) {
            if (thisvar.available == false) {
              $(this).addClass("outofstock");
            } else {
              $(this).removeClass("outofstock");
            }
            break;
          }
        }
      });
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) => {
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      );
    });

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
    localStorage.setItem("selectedVariant", this.currentVariant.id);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      // pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        /* Preorder start */
        const variantInputSelector =
          'input[name="id"][value="' + this.currentVariant.id + '"]';
        const variantInputSource = html.querySelector(variantInputSelector);
        const variantInputDestination =
          document.querySelector(variantInputSelector);

        if (variantInputSource && variantInputDestination) {
          variantInputDestination.dataset.preorder =
            variantInputSource.dataset.preorder;
          variantInputDestination.dataset.preorderArrivalDate =
            variantInputSource.dataset.preorderArrivalDate;
        }

        const preorderArrivalDateId = "preorder-arrival-date";
        const arrivalDateSource = html.getElementById(preorderArrivalDateId);
        const arrivalDateDestination = document.getElementById(
          preorderArrivalDateId
        );
        if (arrivalDateSource && arrivalDateDestination)
          arrivalDateDestination.innerHTML = arrivalDateSource.innerHTML;

        const productCarouselBadgeId = '[data-product-carousel-badge]';
        const productCarouselBadgeSource = html.querySelector(productCarouselBadgeId);
        const productCarouselBadgeDestination = document.querySelector(productCarouselBadgeId);

        if (productCarouselBadgeSource && productCarouselBadgeDestination)
          productCarouselBadgeDestination.replaceWith(productCarouselBadgeSource);
        /* Preorder end */

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      /* Preorder start */
      const inputId = productForm.querySelector('input[name="id"]');
      console.log(inputId.dataset.preorder + "fgffsdfsd");
      if (inputId.dataset.preorder === "true") {
        $(".product-button-container").css("display", "grid");
        $(".emailproduuct--button").show();
        addButtonText.innerHTML = `<svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                              >
                                <rect width="18" height="18" fill="url(#pattern0_1_9)"/>
                                <defs>
                                <pattern id="pattern0_1_9" patternContentUnits="objectBoundingBox" width="1" height="1">
                                <use xlink:href="#image0_1_9" transform="scale(0.00195312)"/>
                                </pattern>
                                <image id="image0_1_9" width="512" height="512" xlink:href="data:image/png;base64,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"/>
                                </defs>
                              </svg><span>${window.variantStrings.preorder}</span>`;
      } else {
        $(".product-button-container").css("display", "flex");
        $(".emailproduuct--button").hide();
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      /* Preorder end */
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class cartrecommendation extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".cart-recommendation-slider", {
        slidesPerView: 1.5,
        spaceBetween: 15,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
        },
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("cart-recommendation", cartrecommendation);

$(document).ready(function () {
  $("cart-recommendation .arrow-container .prev").click(function () {
    $("cart-recommendation .swiper-button-prev").trigger("click");
  });
  $("cart-recommendation .arrow-container .next").click(function () {
    $("cart-recommendation .swiper-button-next").trigger("click");
  });
});

class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.init();

    // Add resize observer to update container height
    // const resizeObserver = new ResizeObserver((entries) => this.update());
    // resizeObserver.observe(this);
    this.dragThreshold =
      this.getAttribute("data-drag-threshold") || this.imageWidth / 4; // Default to 1/4th if not provided

    // Bind event listeners
    this.navItems.forEach((item) =>
      item.addEventListener("click", this.onNavItemClick.bind(this))
    );
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    // Listen for variant selection change to make current variant image active
    window.addEventListener("message", this.onVariantChange.bind(this));
    window.addEventListener("resize", this.onResize.bind(this));
    this.isDragging = false;
    this.dragExecuted = false; // Add this flag
    this.startX = 0;
    this.currentX = 0;

    // Determine if the user's device supports touch events
    this.isTouch = "ontouchstart" in window || navigator.msMaxTouchPoints;

    // Add touch event listeners for mobile
    if (this.isTouch) {
      this.addEventListener("touchstart", this.onDragStart.bind(this));
      this.addEventListener("touchmove", this.onDragMove.bind(this));
      this.addEventListener("touchend", this.onDragEnd.bind(this));
    } else {
      // Add mouse event listeners for desktop
      this.addEventListener("mousedown", this.onDragStart.bind(this));
      this.addEventListener("mousemove", this.onDragMove.bind(this));
      this.addEventListener("mouseup", this.onDragEnd.bind(this));
    }
  }

  init() {
    // Set up our DOM element variables
    this.imagesContainer = this.querySelector(".product-gallery__images");
    this.navItems = this.querySelectorAll(".product-gallery__nav-item");
    this.images = this.querySelectorAll(".product-gallery__image");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.navContainer = this.querySelector(".product-gallery__nav"); // Adjust the selector to match your HTML
    // If there is no active images set the first image to active

    this.changedProductGallery = new CustomEvent("changedProductGallery");

    if (this.findCurrentIndex() === -1) {
      this.setCurrentImage(this.images[0]);
    }

    this.imageWidth = this.images[0].offsetWidth;
    this.imagesContainer.style.transform = `translateX(${0}px)`;

    const variantId = this.getVariantFromURL();

    // If a variant is found in the URL, navigate to the corresponding slide
    // if (variantId) {
    //   const variants = $(this).data("variantjson");
    //   console.log(variants)
    //   console.log(variantId)
    //   const returnCurrVar = variants.find((item) => item.id == variantId);
    //   const currentImage = Array.from(this.images).find(
    //     (item) => item.dataset.mediaId == returnCurrVar.featured_media.id
    //   );
    //   if (currentImage) {
    //     this.setCurrentImage(currentImage);
    //   }
    // }
  }

  onVariantChange(event) {
    if (!event.data || event.data.type !== "variant_changed") return;
      if(event.data.variant.featured_media){
      const currentImage = Array.from(this.images).find(
        (item) => item.dataset.mediaId == event.data.variant.featured_media.id
      );
      if (currentImage) {
        this.setCurrentImage(currentImage);
      }
    }
  }

  onNavItemClick(event) {
    const mediaId = event.target.closest("li").dataset.mediaId;
    this.images.forEach((item) =>
      item.classList.remove("product-gallery__image--active")
    );
    this.setCurrentImage(
      Array.from(this.images).find((item) => item.dataset.mediaId === mediaId)
    );
  }

  onDragStart(event) {
    this.isDragging = true;
    this.dragExecuted = false;
    this.lastTime = Date.now();

    if (event.type === "touchstart") {
      this.startX = event.touches[0].clientX;
    } else if (event.type === "mousedown") {
      this.startX = event.clientX;
    }

    this.currentX = this.startX;
  }

  onDragMove(event) {
    if (!this.isDragging || this.dragExecuted) return;

    const currentTime = Date.now();
    if (currentTime - this.lastTime < 16) return; // Throttle the event handling to around 60fps
    this.lastTime = currentTime;

    if (event.type === "touchmove") {
      this.currentX = event.touches[0].clientX;
    } else if (event.type === "mousemove") {
      this.currentX = event.clientX;
    }

    const difference = this.currentX - this.startX;
    const threshold = this.dragThreshold; // Use the already computed threshold

    if (difference > threshold) {
      this.onButtonClick({ currentTarget: { name: "previous" } });
      this.startX = this.currentX;
      this.dragExecuted = true;
    } else if (difference < -threshold) {
      this.onButtonClick({ currentTarget: { name: "next" } });
      this.startX = this.currentX;
      this.dragExecuted = true;
    }
  }

  onDragEnd(event) {
    this.isDragging = false;
    this.dragExecuted = false; // Reset the flag
  }

  update() {
    this.style.height = `${this.imagesContainer.offsetHeight}px`;
    this.prevButton.removeAttribute("disabled");
    this.nextButton.removeAttribute("disabled");
    if (this.findCurrentIndex() === 0)
      this.prevButton.setAttribute("disabled", true);
    if (this.findCurrentIndex() === this.images.length - 1)
      this.nextButton.setAttribute("disabled", true);
  }

  setCurrentImage(elem) {
    this.images.forEach((item) =>
      item.classList.remove("product-gallery__image--active")
    );
    if (!elem) return;
    elem.classList.add("product-gallery__image--active");
    const index = this.findCurrentIndex();
    this.imagesContainer.style.transform = `translateX(${
      -index * this.imageWidth
    }px)`;
    this.updateNav(index); // Call the new method to update navigation
    this.update();
    //console.log(elem);
    if (elem.classList.contains("video")) {
      window.pauseAllMedia();
      this.loadContent();
    } else {
      if (elem.classList.contains("video")) {
        window.pauseAllMedia();
      }
    }
  }

  findCurrentIndex() {
    return Array.from(this.images).findIndex((item) =>
      item.classList.contains("product-gallery__image--active")
    );
  }

  onButtonClick(event) {
    if (event.preventDefault) {
      event.preventDefault();
    }

    let index = this.findCurrentIndex();
    if (event.currentTarget.name === "next") {
      if (index < this.images.length - 1) {
        index++;
      } else {
        // Handle boundary error
        console.error("Cannot go to next image, already at the last one.");
        return;
      }
    } else {
      if (index > 0) {
        index--;
      } else {
        // Handle boundary error
        console.error("Cannot go to previous image, already at the first one.");
        return;
      }
    }
    this.setCurrentImage(this.images[index]);
  }

  onResize() {
    this.imageWidth = this.images[0].offsetWidth;
    this.setCurrentImage(this.images[this.findCurrentIndex()]);
  }

  updateNav(activeIndex) {
    const headerHeight = 100; // Adjust to match the height of your fixed header
    this.navItems.forEach((item, index) => {
      if (index === activeIndex) {
        item.classList.add("product-gallery__nav-item--active");
        const container = this.navContainer; // Assuming this is the scrollable container
        const targetScrollPosition =
          item.offsetTop - container.offsetTop - headerHeight;
        this.smoothScroll(targetScrollPosition); // Scroll the container smoothly
      } else {
        item.classList.remove("product-gallery__nav-item--active");
      }
    });
  }

  smoothScroll(target) {
    const container = this.navContainer;
    const startPosition = container.scrollTop;
    const difference = target - startPosition;
    const duration = 300; // Adjust the scrolling duration as needed
    let startTime = null;

    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      container.scrollTop = startPosition + progress * difference;
      if (progress < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }
  onMouseMove(event) {
    const image = this.imagesContainer.querySelector(
      ".product-gallery__image--active"
    );
    const rect = image.getBoundingClientRect();
    const xPos = (event.clientX - rect.left) / rect.width;
    const yPos = (event.clientY - rect.top) / rect.height;
    image.style.transformOrigin = `${xPos * 100}% ${yPos * 100}%`;
    image.style.transform = "scale(2)"; // Adjust the magnification level
  }

  onMouseLeave() {
    const image = this.imagesContainer.querySelector(
      ".product-gallery__image--active"
    );
    image.style.transformOrigin = "center center";
    image.style.transform = "scale(1)";
  }

  getVariantFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("variant");
  }

  loadContent(focus = true) {
    let deferredElement = this.querySelector(
      ".product-gallery__images-container .video deferred-media"
    );
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      const videoElement = this.querySelector("template")
        .content.querySelector("video")
        .cloneNode(true);

      // Set autoplay attribute to the video
      videoElement.setAttribute("autoplay", true);

      content.appendChild(videoElement);
      this.setAttribute("loaded", true);
      deferredElement = this.querySelector(
        ".product-gallery__images-container .video deferred-media"
      ).appendChild(videoElement);
      if (focus) deferredElement.focus();

      // Play the video
      deferredElement.play();
    } else {
      if (
        this.querySelector(
          ".product-gallery__images-container .video deferred-media video"
        ).paused
      ) {
        this.querySelector(
          ".product-gallery__images-container .video deferred-media video"
        ).play();
      }
    }
  }
}

customElements.define("product-gallery", ProductGallery);

let sendGa41 = function (t) {
  let e = document.querySelector(".sticky-button");
  if (e && "sold out" === e.firstElementChild.innerText.toLowerCase()) {
    let i = document
        .querySelector(".product-form form")
        .querySelector('input[name="id"]').value,
      a = 0;
    a = t
      ? t.target.getAttribute("data-index")
      : document
          .querySelector("input.custom-swatch-input:checked")
          .getAttribute("data-index");
    let s = window.productVariants.find((t) => t.id == i);
    !1 == s.available &&
      gtag("event", "out_of_stock", {
        sent_from: "Custom tracking",
        send_to: "G-8K4PXNJVLS",
        store_name: Shopify.shop,
        item_name: s.name,
        item_id: s.id,
        index: a,
        quantity: 1,
        item_variant: s.public_title,
      });
  }
};

document.addEventListener("alpine:init", () => {
  setTimeout(function () {
    sendGa41();
  }, 1500),
    Alpine.data("swatchesSelection", () => ({
      changeInput: function (t) {
        let e = t.target.nextElementSibling.classList;
        if (e.contains("custom-input-labels")) {
          let i = document.querySelectorAll(".custom-input-labels");
          for (let a = 0; a < i.length; a++)
            i[a].classList.remove(
              "shadow-[0px_0px_0px_5px_rgba(255,255,255,1),0px_0px_0px_6px_rgba(23,27,29,1)]"
            );
          e.add(
            "shadow-[0px_0px_0px_5px_rgba(255,255,255,1),0px_0px_0px_6px_rgba(23,27,29,1)]"
          );
        }
        setTimeout(function () {
          window.bisShow && window.bisShow(), sendGa41(t);
        }, 1500);
        let s = document.querySelector('input[name="id"]');
        setTimeout(function () {
          s.value &&
            (document
              .getElementsByClassName("swym-add-to-wishlist-view-product")[0]
              .setAttribute("data-variant-id", s.value),
            window._swat
              ? window._swat.initializeActionButtons(".pdp-swym")
              : ((window.SwymCallbacks = window.SwymCallbacks || []),
                window.SwymCallbacks.push(function () {
                  window._swat.initializeActionButtons(".pdp-swym");
                })));
        }, 500),
          (t.target.parentElement.querySelector(".option-title").innerText =
            t.target.value);
      },
      selectSwatchOnLoad: function () {
        let t = this,
          e = document.getElementById("main-gallery"),
          i = new MutationObserver((e) => {
            for (let a of e)
              if ("attributes" === a.type && "class" === a.attributeName) {
                let s = a.target;
                s.classList.contains("is-initialized") &&
                  (console.log(
                    'Class "is-initialized" has been added to the div.'
                  ),
                  t.$refs.currentSwatch.click(),
                  i.disconnect());
              }
          });
        i.observe(e, { attributes: !0 });
      },
    })),
    Alpine.data("submitOutOfStock", () => ({
      emailValid: !1,
      emailInvalid: !1,
      initialState: !1,
      isSuccessMessage: !1,
      successContent:
        "Success! We'll let you know when this item is back in stock.",
      errorContent: "Please enter a correct email address.",
      init() {
        let t = this;
        (window.bisShow = function () {
          document.querySelector(".bis-input");
          let e = document.querySelector(".sticky-button");
          e && "sold out" === e.firstElementChild.innerText.toLowerCase()
            ? (t.initialState = !0)
            : (t.initialState = !1);
        }),
          setTimeout(function () {
            window.bisShow();
          }, 1500);
      },
      submitToKlaviyo(t) {
        let e = {
            account: "KGCmEv",
            platform: "shopify",
            product: "{{ product.id }}",
            subscribe_for_newsletter: !1,
          },
          i = document.querySelector(".bis-email");
        if (
          localStorage.getItem("selectedVariant")
            ? localStorage.getItem("selectedVariant")
            : "{{ product.selected_or_first_available_variant.id }}"
        ) {
          let s = `{
                "data": {
                  "type": "back-in-stock-subscription",
                  "attributes": {
                    "profile": {
                      "data": {
                        "type": "profile",
                        "attributes": {
                          "email": "${i.value}"
                        } 
                      }
                    },
                    "channels": ["EMAIL"]
                  },
                  "relationships": {
                    "variant": {
                      "data": {
                        "type": "catalog-variant",
                        "id": "$shopify:::$default:::${localStorage.getItem(
                          "selectedVariant"
                        )}"
                      }
                    }
                  }
                }
              }`;
          this.validateEmail(i.value)
            ? fetch(
                "https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=KGCmEv",
                {
                  method: "POST",
                  body: s,
                  headers: {
                    "Content-Type": "application/json",
                    revision: "2024-07-15",
                    accept: "application/json",
                  },
                }
              ).then(
                function (t) {
                  t.status;
                },
                function (t) {}
              )
            : i.classList.remove("error");
        }
      },
      validateEmail(t) {
        return /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(
          t
        )
          ? ((this.emailInvalid = !1), (this.emailValid = !0), !0)
          : ((this.emailInvalid = !0), (this.emailValid = !1), !1);
      },
    })),
    Alpine.data("submitOutOfStockPreorder", () => ({
      emailValid: !1,
      emailInvalid: !1,
      initialState: !1,
      isSuccessMessage: !1,
      successContent:
        "Success! We'll let you know when this item is back in stock.",
      errorContent: "Please enter a correct email address.",
      init() {
        let t = this;
        (window.bisShow = function () {
          document.querySelector(".bis-input");
          let e = document.querySelector(".sticky-button");
          e && "sold out" === e.firstElementChild.innerText.toLowerCase()
            ? (t.initialState = !0)
            : (t.initialState = !1);
        }),
          setTimeout(function () {
            window.bisShow();
          }, 1500);
      },
      submitToKlaviyoPreorder(t) {
        let e = {
            account: "KGCmEv",
            platform: "shopify",
            product: "{{ product.id }}",
            subscribe_for_newsletter: !1,
          },
          i = document.querySelector(".bis-email-preorder");
        if (
          localStorage.getItem("selectedVariant")
            ? localStorage.getItem("selectedVariant")
            : "{{ product.selected_or_first_available_variant.id }}"
        ) {
          let s = `{
                "data": {
                  "type": "back-in-stock-subscription",
                  "attributes": {
                    "profile": {
                      "data": {
                        "type": "profile",
                        "attributes": {
                          "email": "${i.value}"
                        } 
                      }
                    },
                    "channels": ["EMAIL"]
                  },
                  "relationships": {
                    "variant": {
                      "data": {
                        "type": "catalog-variant",
                        "id": "$shopify:::$default:::${localStorage.getItem(
                          "selectedVariant"
                        )}"
                      }
                    }
                  }
                }
              }`;
          this.validateEmail(i.value)
            ? fetch(
                "https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=KGCmEv",
                {
                  method: "POST",
                  body: s,
                  headers: {
                    "Content-Type": "application/json",
                    revision: "2024-07-15",
                    accept: "application/json",
                  },
                }
              ).then(
                function (t) {
                  t.status;
                },
                function (t) {}
              )
            : i.classList.remove("error");
        }
      },
      validateEmail(t) {
        return /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(
          t
        )
          ? ((this.emailInvalid = !1), (this.emailValid = !0), !0)
          : ((this.emailInvalid = !0), (this.emailValid = !1), !1);
      },
    }));
});

$(window).on("load", function () {
  var intid = setInterval(function () {
    $(".yotpo-pictures-widget .yotpo-image").each(function () {
      var src = $(this).attr("src");
      if (src.indexOf("low_resolution") != -1) {
        var newsrc = src.replace("low_resolution", "standard_resolution");
        $(this).attr("src", newsrc);
      }
    }, 2000);
  });
});

  document.addEventListener("DOMContentLoaded", function() {
    // Target only the specific fade-in container
    var content = document.querySelector(".yotpo-widget-instance-container.fade-in");
    if (content) {
      setTimeout(function() {
        content.classList.add("show");
      }, 2000); // 2000 milliseconds = 2 seconds delay
    }
  });



// header and banner height get

// function updateViewportHeight() {
//   const header = document.querySelector(".header-wrapper");
//   const announcement = document.querySelector(".custom-announcement-bar");

//   const headerHeight = header ? header.offsetHeight : 0;
//   const announcementHeight = announcement ? announcement.offsetHeight : 0;

//   const vh = window.innerHeight;

//   // Set --available-header-height (excluding only header)
//   const availableHeaderHeight = headerHeight * -1;
//   document.documentElement.style.setProperty(
//     "--available-header-height",
//     `${availableHeaderHeight}px`
//   );

//   // Set --available-height (excluding only announcement)
//   const availableHeight = vh - announcementHeight;
//   document.documentElement.style.setProperty(
//     "--available-height",
//     `${availableHeight}px`
//   );
// }
// updateViewportHeight()
// window.addEventListener("load", updateViewportHeight);
// window.addEventListener("resize", updateViewportHeight);


function updateViewportHeight() {
  const header = document.querySelector(".header-wrapper");
  const announcement = document.querySelector(".custom-announcement-bar");
  const headerHeight = header ? header.offsetHeight : 0;
  const announcementHeight = announcement ? announcement.offsetHeight : 0;

  const vh = window.innerHeight;

  // --available-header-height
  const availableHeaderHeight = headerHeight * -1;
  document.documentElement.style.setProperty(
    "--available-header-height",
    `${availableHeaderHeight}px`
  );

  // --available-height
  const availableHeight = vh - announcementHeight;
  document.documentElement.style.setProperty(
    "--available-height",
    `${availableHeight}px`
  );
}

let initialVH; // store initial height for mobile

function updateViewportHeightWithMobileFix() {
  const isMobile = window.innerWidth <= 768; // adjust if needed

  if (isMobile) {
    if (!initialVH) {
      initialVH = window.innerHeight;
    }

    const header = document.querySelector(".header-wrapper");
    const announcement = document.querySelector(".custom-announcement-bar");
    const headerHeight = header ? header.offsetHeight : 0;
    const announcementHeight = announcement ? announcement.offsetHeight : 0;

    const availableHeaderHeight = headerHeight * -1;
    document.documentElement.style.setProperty(
      "--available-header-height",
      `${availableHeaderHeight}px`
    );

    const availableHeight = initialVH - announcementHeight;
    document.documentElement.style.setProperty(
      "--available-height",
      `${availableHeight}px`
    );
  } else {
    updateViewportHeight(); // desktop: update normally
  }
}

updateViewportHeightWithMobileFix();
window.addEventListener("load", updateViewportHeightWithMobileFix);
window.addEventListener("resize", updateViewportHeightWithMobileFix);

// end



// document.addEventListener('DOMContentLoaded', () => {
//   const revealElements = document.querySelectorAll('.reveal-text');

//   const observer = new IntersectionObserver((entries, observer) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         entry.target.classList.add('visible');
//         observer.unobserve(entry.target); // Remove if only once
//       }
//     });
//   }, {
//     threshold: 0.3,
//     rootMargin: '0px 0px 0% 0px'
//   });

//   revealElements.forEach(el => observer.observe(el));
// });

function initRevealObserver() {
  const revealElements = document.querySelectorAll('.reveal-text');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target); // Remove if only once
      }
    });
  }, {
    threshold: 0.3,
    rootMargin: '0px 0px 0% 0px'
  });

  revealElements.forEach(el => observer.observe(el));
}

// Run on page load
document.addEventListener('DOMContentLoaded', initRevealObserver);

// Also run when section is reloaded inside Theme Customizer
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', initRevealObserver);
}

